// extracted by mini-css-extract-plugin
export default {"seoBlockContent":"c-a_fB","seoBlockContent_visible":"c-a_fC"};